export const SOLUTION_DETAIL_SLUGS = [
  'finance-consulting',
  'risk-resilience',
  'business-strategy',
  'liquidity-consulting',
  'financial-marketing',
  'fintech-consulting',
];

export const isSolutionDetailPage = (pageSlug) =>
  SOLUTION_DETAIL_SLUGS.includes(pageSlug);
